import * as React from 'react';

// declare module '*.svg' {
//   const ReactComponent: React.FC<React.SVGProps<SVGSVGElement>>;
//   const src: string;
//   export { ReactComponent };
//   export default src;
// }

type SvgComponentProps = {
  file: string;
  width?: number | string;
  height?: number | string;
  alt?: string;
  className?: string;
};

function SvgComponent({
  file,
  width,
  height,
  alt,
  className,
  ...props
}: SvgComponentProps) {
  if (file) {
    // Only pass img-allowed props to <img>
    return (
      <img
        src={file}
        alt={alt}
        width={width as number | string | undefined}
        height={height as number | string | undefined}
        className={className}
        {...props}
      />
    );
  } else {
    return null;
  }
}
export default SvgComponent;
export { SvgComponent };
